import React, { useCallback, useEffect, useState, useContext } from 'react'
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import { SimpleTreeView } from  '@mui/x-tree-view'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import FolderTreeItem from './FolderTreeItem'
import { FoldersGetContents } from 'modules/Rest'
import { MessageContext } from './Contexts'
import { useIsMounted } from 'modules/Utils'

const ExpandIcon = withStyles({
  root: {
    color: '#666',
  },
})(AddIcon)

const MinimizeIcon = withStyles({
  root: {
    color: '#666',
  },
})(RemoveIcon)

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: '400px',
  },
}))

const rightsSelection = [
  [
    { label: 'Default', value: 'null' },
    { label: 'No access', value: '[false,false,false,false,false]' },
    { label: 'Read only access', value: '[true,false,false,false,false]' },
    { label: 'Read only access - PDF watermarking', value: '[true,false,true,false,false]' },
    { label: 'Read only access - Secure PDF Viewer', value: '[true,false,false,true,false]' },
    { label: 'Read and write access', value: '[true,true,false,false,false]' },
    { label: 'Read and write access - PDF watermarking', value: '[true,true,true,false,false]' },
  ],
  [
    { label: 'Default', value: 'null' },
    { label: 'No access', value: '[false,false,false,false,false]' },
    { label: 'Read only access', value: '[true,false,false,false,false]' },
    { label: 'Read only access - Hidden folder', value: '[true,false,false,false,true]' },
    { label: 'Read and write access', value: '[true,true,false,false,false]' },
  ],
]

export default function FolderTree({ dataRoom, userType, lightDataRoom }) {
  const classes = useStyles()
  const [toggledNodes, setToggledNodes] = useState(null)
  const [topFolder, setTopFolder] = useState(null)
  const { messageDispatch } = useContext(MessageContext)
  const isMounted = useIsMounted()

  const fetchTopFolder = useCallback(async () => {
    setTopFolder(null)
    try {
      const { data: { folder, success, info } } = await FoldersGetContents({
        data_room: dataRoom,
        rights_user_type: userType,
        incl_folders: false,
      })
      if (success && folder && isMounted.current) {
        setTopFolder(folder)
        setToggledNodes([folder.folder])
      } else if (!success && isMounted.current) {
        throw new Error(info ? info : 'An error occurred')
      }
    } catch (error) {
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [dataRoom, userType, isMounted, messageDispatch])

  useEffect(() => {
    fetchTopFolder()
  }, [dataRoom, userType, fetchTopFolder])

  const onNodeToggle = (event, nodeIds) => {
    if (event.target.tagName === 'path' || event.target.tagName === 'svg') {
      if (nodeIds.length) {
        setToggledNodes(nodeIds)
      } else {
        setToggledNodes([])
      }
    }
  }

  return (
    <div className={classes.root}>
      {topFolder && <SimpleTreeView
        slots={{
          expandIcon: ExpandIcon,
          collapseIcon: MinimizeIcon,
        }}
        onExpandedItemsChange={onNodeToggle}
        expanded={toggledNodes}
        defaultExpandedItems={[topFolder.folder]}
        expansionTrigger="iconContainer"
      >
        <FolderTreeItem
          nodeId={topFolder.folder}
          userType={userType}
          folder={topFolder}
          autoload={true}
          toggledNodes={toggledNodes}
          onReload={fetchTopFolder}
          rightsSelection={rightsSelection[lightDataRoom ? 1 : 0]}
        />
      </SimpleTreeView>}
    </div>
  )
}
